var chunkMapping = {
	"141": [
		6141
	],
	"509": [
		509
	],
	"735": [
		7735
	]
};
var idToExternalAndNameMapping = {
	"509": [
		"default",
		"./mutation-grid-header",
		3635
	],
	"6141": [
		"default",
		"./mutation-grid-content",
		3635
	],
	"7735": [
		"default",
		"./mutation-grid-item",
		3635
	]
};
var idToRemoteMap = {
	"509": [
		{
			"externalType": "script",
			"name": "mutationsApp"
		}
	],
	"6141": [
		{
			"externalType": "script",
			"name": "mutationsApp"
		}
	],
	"7735": [
		{
			"externalType": "script",
			"name": "mutationsApp"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"509": {
		"shareScope": "default",
		"name": "./mutation-grid-header",
		"externalModuleId": 3635,
		"remoteName": "mutationsApp"
	},
	"6141": {
		"shareScope": "default",
		"name": "./mutation-grid-content",
		"externalModuleId": 3635,
		"remoteName": "mutationsApp"
	},
	"7735": {
		"shareScope": "default",
		"name": "./mutation-grid-item",
		"externalModuleId": 3635,
		"remoteName": "mutationsApp"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}